// extracted by mini-css-extract-plugin
export default {"commaList":"_0aYKV0G1--InlineCommaList_commaList__xRvZo"};